import {useState} from "react";
import {useTranslation} from "react-i18next";

const SentryFallbackPage = ({error, resetErrorBoundary}) => {
    const {t} = useTranslation()
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (navigator?.clipboard?.writeText) {
            navigator.clipboard.writeText(
                error?.stack || error?.message || String(error)
            );
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <section className="sentryFallbackPage">
            <div className="container">
                <div className="row">
                    <h2>{t("errors.reloadPageError")}</h2>
                    <p>{t("errors.reloadPageErrorDetail")}</p>
                    <pre>{error?.message || String(error)}</pre>
                    <div className="btnGroup">
                        <button onClick={handleCopy}>
                            {copied ? t("messages.copy") : t("errors.copyError")}
                        </button>
                        <button onClick={resetErrorBoundary}>{t("errors.reloadPageErrorBtn")}</button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SentryFallbackPage;
